import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="min-h-screen bg-auth-gradient text-white flex flex-col p-5 overflow-hidden">
      {/* Centered Section */}
      <div className="flex-grow flex items-center justify-center relative z-10">
        <div className="relative max-w-[560px] w-full mx-auto flex-center flex-col">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
